import { ProfileResponse } from 'models/auth/interfaces/auth.interface';
import { CompanyRole } from 'models/companies/enums/companies.enums';
import { UserType } from 'models/user-management/enums/user-management.enum';

const MOBILE_BREAKPOINT = 768;

export const isMobileViewport = (): boolean =>
	typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT;

export const getPostLoginPath = (user: ProfileResponse): string => {
	if (
		user.type === UserType.ADMIN &&
		user.company?.role === CompanyRole.ADMIN
	) {
		return '/companies';
	}
	if (user.type === UserType.DRIVER) {
		return '/map';
	}
	if (isMobileViewport()) {
		return '/map';
	}
	return '/dashboard';
};
